import React, { useState, useId } from 'react';

const TITLE = 'Privacy Policy';
const LAST_UPDATED = '2026-07-22';

const Privacy = ({ onDismiss }) => {
  const [acknowledged, setAcknowledged] = useState(false);
  const id = useId();

  return (
    <div className="privacy-overlay" role="dialog" aria-labelledby={`${id}-title`} aria-modal="true">
      <div className="privacy-dialog">
        <div className="privacy-header">
          <h2 id={`${id}-title`}>{TITLE}</h2>
          <button type="button" className="privacy-close" onClick={onDismiss} aria-label="Close privacy">
            Close
          </button>
        </div>

        <div className="privacy-body">
          <p className="privacy-updated">Last updated: {LAST_UPDATED}</p>

          <h3>Short version</h3>
          <p>
            $KEK is provided for entertainment purposes only. This privacy policy explains what
            little data this site touches and what we do not do. It is written to be useful,
            not theatrical.
          </p>

          <h3>What this site collects</h3>
          <ul>
            <li>Wallet connection metadata required by WAX wallet providers, where you choose to connect.</li>
            <li>No user accounts, email collection, or server-side profiles are created by the Wax Pepe site itself.</li>
            <li>No advertising, analytics, tracking pixels, or third-party marketing SDKs are loaded.</li>
          </ul>

          <h3>Cookies and local storage</h3>
          <ul>
            <li>No tracking cookies are set.</li>
            <li>The site may use local storage to remember consent preferences and UI settings.</li>
            <li>You can clear this data at any time in your browser settings.</li>
          </ul>

          <h3>Third-party links</h3>
          <ul>
            <li>External venues such as Alcor DEX have their own privacy and cookie practices. We are not responsible for them.</li>
            <li>Click any external link at your own discretion and review its terms before using it.</li>
          </ul>

          <h3>Your rights and controls</h3>
          <ul>
            <li>Do not provide personal data if you do not want it on a public blockchain.</li>
            <li>Refrain from connecting a wallet if you are unsure about blockchain transparency.</li>
            <li>Contact the operator if you need a records request, answer, or deletion request related to this site.</li>
          </ul>

          <h3>Contact</h3>
          <p>
            Operator contact: use the site contact channel. Do not send secrets, passwords, or private keys.
          </p>
        </div>

        <div className="privacy-footer">
          <label className="privacy-ack">
            <input
              type="checkbox"
              checked={acknowledged}
              onChange={(event) => setAcknowledged(event.target.checked)}
            />
            I understand this is an entertainment-only project with no investment intent.
          </label>
          <div className="privacy-actions">
            <button type="button" className="btn btn-primary" onClick={onDismiss}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;

export { TITLE, LAST_UPDATED };
